<div class="clickable cart-button-wrapper" (click)="onShoppingBasketClick()">
  <mat-icon  [matBadge]="getNumberOfShoppingBasketItems()"
    matBadgePosition="after" matBadgeColor="accent">shopping_cart</mat-icon>
</div>